/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
/* eslint-disable comma-dangle */
/* eslint-disable indent */
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Button from "../elements/Button/index";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const EMSForm = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    company: "",
    role: "",
    portfolio: "",
    message: "",
  });

  const formSectionRef = useRef(null);

  useEffect(() => {
    if (!siteKey) {
      return undefined;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: value,
      [id]: type === "checkbox" ? checked : value,
    });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      if (!window.grecaptcha) throw new Error("reCAPTCHA is not loaded");

      const token = await window.grecaptcha.execute(siteKey, {
        action: "submit",
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/ems`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...formData, token }),
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        toast.success(result.message || "Message sent successfully!");
        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          company: "",
          role: "",
          portfolio: "",
          message: "",
        });
      } else {
        toast.error(result.message || "Failed to send the message.");
      }
    } catch (error) {
      toast.error("Failed to send the message.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    setTimeout(() => {
      const inputElement = document.getElementById('firstname');
      if (inputElement) {
        inputElement.focus();
      }
    }, 300);
  };

  const scrollToDiscovery = () => {
    const element = document.getElementById("dashboard");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <main>
      <section className="w-full pb-12 overflow-hidden relative pt-4  bg-[linear-gradient(to_bottom,#000000_50%,white_47%)] lg:bg-[linear-gradient(to_right,#000000_52%,white_52%)] dark:lg:bg-[linear-gradient(to_right,#000000_50%,#000000_50%)] dark:bg-[linear-gradient(to_bottom,#000000_47%,#000000_47%)]">
        <div className="container mx-auto lg:pl-12 px-6 lg:max-w-screen-xl items-center">
          <div className="gap-6 relative flex flex-col lg:flex-row justify-between gap-10  ">
            <div className="lg:w-1/2 flex flex-col gap-6 relative lg:bg-transparent">
              <div className=" overflow-hidden lg:block absolute top-[-120px] left-[290px] w-[250px] h-[250px] lg:w-[450px] lg:h-[450px] bg-[#459ca5] opacity-10 rounded-full pointer-events-none z-0" />
              <div className="lg:mt-28 mt-12 text-center lg:text-left flex flex-col gap-6 ">
                <span className="text-theme-yellow uppercase tracking-widest text-md"> Energy Management System</span>
                <h1 className="text-4xl lg:text-5xl font-bold text-white max-w-3xl mx-auto lg:mx-0 dark:text-white">
                  Smart Energy Management. <span className="text-theme-yellow text-4xl lg:text-5xl"> <br />  Made Simple.</span>
                </h1>
                <div className="flex flex-col gap-6 text-gray-300 font-light text-base lg:text-lg max-w-3xl pr-4 text-gray-400">
                  <p>Energy data is complex. Compliance is demanding.</p>
                  <p className="w-full mt-4 text-center lg:text-left max-w-3xl text-lg font-light text-gray-400">
                    Nube iO gives building owners, facility managers, and contractors
                    complete visibility and control across every site — from a single device
                    to an entire portfolio. NABERS, Green Star, ESG and NCC reporting,
                    built in.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 mt-8 mb-12 items-center justify-center lg:justify-start">
                    <Button className="bg-[#fbb93e] text-black font-semibold py-3 px-8 rounded-xl hover:bg-yellow-500 transition-colors" onClick={scrollToForm}>
                      Get started today
                    </Button>
                    <Button className="bg-transparent text-white font-semibold py-3 px-8 rounded-xl border border-gray-500 hover:border-white transition-colors" onClick={scrollToDiscovery}>
                      See how it works
                    </Button>
                  </div>
                </div>

                <div className="border-t border-gray-700/50" />

                <span className="text-lg font-semibold text-gray-400 uppercase tracking-wider ">
                  Trusted by building teams across Australia and beyond
                </span>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-10">
                  <div>
                    <h4 className="text-2xl font-bold text-white">1,500+</h4>
                    <p className="text-xs text-gray-400 mt-1">Connected building sites</p>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-white">300K+</h4>
                    <p className="text-xs text-gray-400 mt-1">Live data points monitored</p>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-white">25%</h4>
                    <p className="text-xs text-gray-400 mt-1">Avg. reduction in maintenance costs</p>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-white">30+</h4>
                    <p className="text-xs text-gray-400 mt-1">Years of industry experience</p>
                  </div>
                </div>
              </div>
            </div>

            <div id="discovery-form" ref={formSectionRef} className="flex-1 w-full  p-8 lg:p-12 rounded-3xl mt-8 flex flex-col justify-center pt-24">
              <h3 className="text-3xl font-bold text-black mb-2 mt-12 dark:text-white">Book a Discovery Session</h3>
              <p className="text-md text-gray-400 dark:text-gray-300 mb-8 font-light">
                Tell us about your portfolio and we&apos;ll show you exactly what&apos;s possible.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="flex gap-8">
                  <div className="grid w-full items-center gap-3 font-bold text-black dark:text-white">
                    <label htmlFor="firstname">First Name*</label>
                    <input
                      type="text"
                      id="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                      placeholder="First Name"
                      className="w-full p-1 border rounded font-light dark:bg-theme-dark "
                      required
                    />
                  </div>
                  <div className="grid w-full items-center gap-3 font-bold text-black dark:text-white">
                    <label htmlFor="lastname">Last Name*</label>
                    <input
                      type="text"
                      id="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      placeholder="Last Name"
                      className="w-full p-1 border rounded font-light dark:bg-theme-dark "
                      required
                    />
                  </div>

                </div>
                <div className="grid w-full items-center gap-3 font-bold text-black dark:text-white mt-5">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    className="w-full p-1 border rounded font-light dark:bg-theme-dark"
                    required
                  />
                </div>

                <div className="grid w-full items-center gap-3 mb-6 mt-6 font-bold text-black dark:text-white">
                  <label htmlFor="company">Company/Organisation</label>
                  <input
                    type="text"
                    id="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Company/Organisation"
                    className="w-full p-1 border rounded font-light dark:bg-theme-dark"
                  />
                </div>

                <div>
                  <label
                    htmlFor="role"
                    className="font-bold text-black mb-5 mt-5 gap-3 dark:text-white"
                  >
                    Role *
                  </label>
                  <select
                    id="role"
                    value={formData.role}
                    onChange={handleChange}
                    className="w-full p-2 border rounded mt-4 mb-6 font-light text-gray-400 dark:bg-theme-dark"
                  >
                    <option value="">Select your role</option>
                    <option value=" Building Owner / Asset Manager">
                      Building Owner / Asset Manager
                    </option>
                    <option value="Facility Manager / Operator">
                      Facility Manager / Operator
                    </option>
                    <option value="Contractor / Integrator">
                      Contractor / Integrator
                    </option>
                    <option value="IT Manager">IT Manager</option>
                    <option value="C-Suite / Executive">C-Suite / Executive</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="portfolio"
                    className="font-bold text-black mb-5 mt-5 gap-3 dark:text-white"
                  >
                    Number of Sites *
                  </label>
                  <select
                    id="portfolio"
                    name="portfolio"
                    value={formData.portfolio}
                    onChange={handleChange}
                    className="w-full p-2 border rounded mt-4 font-light text-gray-400 dark:bg-theme-dark"
                  >
                    <option value="">Portfolio Size</option>
                    <option value="1 site">
                      1 site
                    </option>
                    <option value="2–10 sites">
                      2–10 sites
                    </option>
                    <option value="11–50 sites">
                      11–50 sites
                    </option>
                    <option value="50+ sites">50+ sites</option>
                  </select>
                </div>

                <div className=" grid w-full items-center gap-3  mb-6 mt-6">
                  <label
                    htmlFor="message"
                    className="mb-2.5 font-bold text-black dark:text-white"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Add any extra details you’d like to share."
                    className="w-full p-2 border rounded font-light mb-2.5 dark:bg-theme-dark dark:text-white"
                    rows="3"
                  />
                </div>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-theme-teal text-white py-2 rounded mt-6 hover:scale-105 hover:bg-white border border-theme-teal hover:text-black"
                >
                  {isSubmitting ? "Sending..." : "Book my Discovery Session"}
                </Button>
                <span className="text-theme-gray font-medium text-xs text-center"> We&apos;ll respond within one business day. No hard sell, just a straight
                  conversation.
                </span>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#eaf4f6] py-8 overflow-hidden pr-20">
        <div className="container mx-auto px-6 lg:px-20 flex flex-wrap items-center justify-center lg:justify-start gap-6 lg:max-w-screen-xl">
          <span className="text-[#459ca5] font-bold text-sm tracking-widest uppercase">
            Compliance Ready
          </span>
          <div className="flex flex-wrap gap-3">
            {['NABERS', 'Green Star', 'ESG', 'NCC', '100% Australian Owned', 'Trusted Globally'].map((item) => (
              <span key={item} className="px-4 py-1 bg-white border border-[#459ca5]/20 rounded-full text-xs text-[#459ca5] font-medium">
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
};

export default EMSForm;
